/**
 * React combo based on the Sementic UI Search field
 * @see http://semantic-ui.com/modules/search.html
 *
 * To use it you need to either include the entire semantic css and js,
 * or the following components:
 *
 *   //cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.1.6/components/icon.css
 *   //cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.1.6/components/dropdown.css
 *   //cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.1.6/components/transition.css
 *   //cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.1.6/components/label.css
 *
 *   //cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.1.6/components/dropdown.js
 *   //cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.1.6/components/api.js
 *   //cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.1.6/components/transition.js
 */

class ReactFieldDropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            disabled: this.props.disabled,
            records: Immutable.fromJS(this.props.records)
        };
    };

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.disabled !== this.state.disabled) {
            this.setState({
                disabled: newProps.disabled
            });
        }
    };

    onChange(value, text, event) {
        if (!this._suppressOnChange) {
            this.props.onChange(value, text, event);
        }

        this.setValue(value);


        /**
         * Fix menu (results) issue when it gets stuck after selecting item/s, usually after selected value is first cleared/removed
         * Happened for State field (after changing Country field) in Crm Record and Add Activity popup from Activity Grid module
         */
        // If it's either multi without value or single with value
        if ((!this.props.singleSelect && !value) || (this.props.singleSelect && value)) {
            $(ReactDOM.findDOMNode(this)).dropdown('hideMenu');
            $(ReactDOM.findDOMNode(this)).dropdown('remove visible');
        }
        // Show menu (results) when it stays behind other fields
        if (!this.props.singleSelect && value && $(ReactDOM.findDOMNode(this)).dropdown('is visible')) {
            $(ReactDOM.findDOMNode(this)).dropdown('set active');
            $(ReactDOM.findDOMNode(this)).dropdown('set visible');
        }
    };

    onKeyUp(value) {
        // If onKeyUp was passed as property - call that one first
        if (this.props.onKeyUp && typeof this.props.onKeyUp === "function") {
            this.props.onKeyUp(value);
        }

        if (this.props.allowTextValue) {
            this.setValue(value);
        }
    };

    setValue(value) {
        this.setState({
            value: value
        });

        if (this.props.allowTextValue) {
            $(ReactDOM.findDOMNode(this)).dropdown('set text', value);
        }
    };

    componentDidMount() {
        // TODO: easy strategy to implement isMount https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted=true;
        var me = this;
        var _initialLoad = true;
        var config = {
            showOnFocus: true,
            delay: {
                search: 500
            },
            saveRemoteData: false,
            allowAdditions: this.props.allowAdditions,
            onChange: this.onChange.bind(this),
            templates: {
                menu: function (response, fields) {
                    var
                        values = response[fields.values] || {},
                        html = '', cls = '', deleted = false, value = null, hasDeletedValue = false;
                    $.each(values, function (index, option) {
                        deleted = false;
                        cls = '';
                        value = option[fields.value]
                        hasDeletedValue = false;

                        if (me.props.hideDeletedValues && Number(option['deleted'])) {
                            cls += ' deleted';
                            deleted = true;

                            if (me.state.value) {
                                if (me.state.value instanceof Array) {
                                    if (me.state.value.indexOf(value) > -1 || me.state.value.indexOf(String(value)) > -1) {

                                        hasDeletedValue = true;
                                    }
                                } else if (me.state.value == value) {
                                    hasDeletedValue = true;
                                }
                            }

                            if (!hasDeletedValue) {
                                cls += ' hidden';
                            }

                        }

                        html += '<div class="item ' + cls + '" data-value="' + value + '">' + option[fields.name] + (deleted ? ' (removed)' : '') + '</div>';
                    });
                    return html;
                }
            }
        };

        if (this.props.allowTextValue) {
            config['forceSelection'] = false;

            // Update value on various places when value is changed by typing
            $(ReactDOM.findDOMNode(this)).on('keyup', function (e) {
                // If it's not Enter or Tab
                if (e.keyCode !== 13 && e.keyCode !== 9) {
                    me.onKeyUp($(this).find('input.search').val());
                }
            });
        }

        if (this.props.url) {
            // When the field is disabled it will not execute the ajax.
            // Temporary remove the 'disabled' class if there is a value
            if (this.props.disabled && this.props.value) {
                $(ReactDOM.findDOMNode(this)).removeClass('disabled');
            }

            config.apiSettings = {
                cache: false,
                url: this.props.url + '?query={query}',
                onResponse: function (response) {
                    // Add back the 'disabled' class after ajax has loaded
                    if (this.props.disabled && this.props.value) {
                        $(ReactDOM.findDOMNode(this)).addClass('disabled');
                    }

                    var records = response[response.metaData.root];
                    this.state.records = Immutable.fromJS(records);

                    if (this.props.setDefault) {
                        setTimeout(function () {
                            this._suppressOnChange = true;
                            if (me._isMounted) {
                                me.setSelected(response);
                            }
                            this._suppressOnChange = false;
                        }.bind(this), 300);
                    } else {
                        if (me._isMounted) {
                            me.setSelected(response);
                        }
                    }

                    return {
                        success: true,
                        results: this._convertRecords(this.state.records)
                    };
                }.bind(this),
                onComplete: function (response) {
                    if (_initialLoad && this.props.value) {
                        _initialLoad = false;
                        setTimeout(function () {
                            this._suppressOnChange = true;
                            if (me._isMounted) {
                                me.setSelected(response);
                            }
                            this._suppressOnChange = false;
                        }.bind(this), 1000);
                    }
                }.bind(this),
                beforeSend: function (settings) {

                    settings.data = this.props.urlParams;
                    if (this.props.autoLoadFirstId) {
                        if (_initialLoad && this.props.value) {
                            settings.data.id = this.props.value
                            if (settings.data.id instanceof Array) {
                                settings.data.id = settings.data.id.join(',');
                            }
                        } else {
                            delete settings.data.id
                        }
                    }
                    return settings;
                }.bind(this)
            };
        } else {
            config.apiSettings = {
                mockResponse: function () {
                    return {
                        results: this._convertRecords(this.state.records)
                    };
                }.bind(this)
            };
        }
        $(ReactDOM.findDOMNode(this)).dropdown(config);
        if (this.props.url) {
            $(ReactDOM.findDOMNode(this)).dropdown('search', '');
        } else {
            this.setSelected();
        }
    };

    componentWillUnmount(){
        // TODO: easy strategy to fix isMounted https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted=false;
    }

    componentDidUpdate() {
        $(ReactDOM.findDOMNode(this)).dropdown('refresh');
        var mainSelect = $(this.refs.mainSelect);

        if (this.state.value) {
            mainSelect.addClass('with-value');
        } else {
            mainSelect.removeClass('with-value');
        }
    };

    getValue() {
        return $(ReactDOM.findDOMNode(this)).dropdown('get value');
    };

    setSelected(response) {
        var val = this.state.value;

        // If it's configured to set default, there is currently no selection and there are records to search for default one
        if (this.props.setDefault && !val && !this.getValue() && response
            && response.metaData && response.metaData.root && response[response.metaData.root] && response.metaData.record) {

            var records = response[response.metaData.root];
            var modelAlias = response.metaData.record;

            records.forEach(function (r) {
                if (!val && r[modelAlias] && r[modelAlias]['is_default'] && r[modelAlias]['is_default'] == true) {

                    val = r[modelAlias]['id'];
                }
            }.bind(this));
        }

        if (val && typeof val.indexOf === "function" && val.indexOf(',') !== -1) {
            var vals = val.split(',');
            vals.forEach(function (singleVal) {
                $(ReactDOM.findDOMNode(this)).dropdown('set selected', singleVal);
            }.bind(this))
        } else {
            $(ReactDOM.findDOMNode(this)).dropdown('set selected', val);
        }


        if (this.props.allowTextValue) {
            $(ReactDOM.findDOMNode(this)).dropdown('set text', val);
        }

        if (this.props.disabled && !this.state.disabled) {
            this.setState({
                disabled: true
            })
        }
    };

    getRecordById(id) {
        return this.state.records.find(function (r) {
            return r.getIn(this.props.idPath) == id;
        }, this);
    };

    getText() {

        if (this.props.singleSelect) {
            return $(ReactDOM.findDOMNode(this)).dropdown('get text');
        } else {
            var values = $(ReactDOM.findDOMNode(this)).dropdown('get values');
            var display = [];
            values.forEach(function (value) {
                var valDisplay = $(ReactDOM.findDOMNode(this)).dropdown('get item', value);
                if (valDisplay) {
                    display.push(valDisplay.html());
                }
            }.bind(this));
            return display.join(', ');
        }
    };

    getTextById(id) {
        var record = this.getRecordById(id);
        return record ? record.getIn(this.props.displayPath) : '';
    };

    onClearValue(event) {
        this.clearValue();
    };

    clearValue() {
        return $(ReactDOM.findDOMNode(this)).dropdown('clear');
    };

    _formatName(r) {
        
        if(this.props.customFormat){
            return this.props.customFormat(r);
        }else{
            return r.getIn(this.props.displayPath)
        }
        
    }

    /**
     * Converts an Immutable.List to an array containing object with 'value' and 'name'
     * to be used in the dropdown results.
     *
     * @param {Immutable.List} records
     * @returns {Array}
     * @private
     */
    _convertRecords(records) {
        var results = [];

        var valueObj = {};
        var deletedPath = this.props.idPath.slice(0);
        deletedPath.pop();
        deletedPath.push('deleted');

        // create records for the Semantic field
        records.forEach(function (r) {
            valueObj = {
                value: r.getIn(this.props.idPath),
                name: this._formatName(r)
            };

            if (this.props.hideDeletedValues) {
                valueObj.deleted = r.getIn(deletedPath)
            }
            results.push(valueObj);
        }.bind(this));

        return results;
    };

    render() {
        var props = this.props;
        var state = this.state;
        var fieldCls = 'ui selection dropdown' +
            (props.singleSelect ? '' : ' multiple') +
            (state.disabled ? ' disabled' : '') +
            (props.inline ? ' inline' : ' fluid') +
            (props.allowSearch ? ' search' : '') +
            (props.hasError ? ' error' : '') +
            (props.url ? ' url' : '');

        var clearButton = null;
        if (state.value && props.allowClear) {
            clearButton = (
                <i className="close icon" onClick={this.onClearValue.bind(this)}/>
            );
            fieldCls += ' with-clear-icon';
        } else {
            fieldCls += ' without-clear-icon';
        }

        var placeHolder = this.props.placeholder;

        if (!this.props.value && this.props.autoLoadFirstId) {
            placeHolder = props.placeholder
        }

        return (
            <div ref='mainSelect' className={fieldCls}>
                <input type="hidden" name={props.name} value={state.value}/>
                <i className={(props.search ? 'search' : 'dropdown') + ' icon'}/>
                {clearButton}
                <div className="default text">{placeHolder}</div>
                <div className="menu"></div>
            </div>
        );
    };
};

ReactFieldDropdown.displayName = 'ReactFieldDropdown';

ReactFieldDropdown.propTypes = {
    placeholder: PropTypes.string,
    // the name of the hidden input
    name: PropTypes.string,
    idPath: PropTypes.arrayOf(PropTypes.string).isRequired,
    displayPath: PropTypes.arrayOf(PropTypes.string).isRequired,
    autoLoadFirstId: PropTypes.bool,
    // passed to 'set selected' http://semantic-ui.com/modules/dropdown.html#behavior
    // DOESNT WORK!
    //value: PropTypes.any,
    records: PropTypes.arrayOf(PropTypes.object), // either this or 'url'
    url: PropTypes.string, // either this or 'records'
    // you should set {limit: 10} or something small to avoid performance issues
    urlParams: PropTypes.object,
    setDefault: PropTypes.bool,
    // Showing suggestions but allowing values not listed in results, similar to autocomplete (currently used for City field in CrmRecord.jsx)
    // todo: Check if "allowAdditions" option should be used
    allowTextValue: PropTypes.bool,
    allowAdditions: PropTypes.bool,
    singleSelect: PropTypes.bool,
    // set to true to show a search icon instead of a dropdown
    search: PropTypes.bool,
    disabled: PropTypes.bool,
    // called exactly the same as here http://semantic-ui.com/modules/dropdown.html#additional-settings
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    inline: PropTypes.bool,
    hideDeletedValues: PropTypes.bool
};

ReactFieldDropdown.defaultProps = {
    allowClear: true,
    allowSearch: true,
    setDefault: false,
    allowAdditions: false,
    singleSelect: true,
    disabled: false,
    onChange: function () {
    },
    onKeyUp: function () {
    }
};